module.exports = __webpack_public_path__ + "img/badge_cond_servizio.9a188046.jpg";